export default __webpack_public_path__ + "static/media/GLI_OPTIONAL.728ad5d1.png";